import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Chat from "./Chat";
import { useSelector } from "react-redux";
import SearchModal from "./SearchModal";
import { RootState } from "../../redux/store";
import { useGetChatSessions } from "./api";
import { ClipLoader } from "react-spinners";

export default function Chatbot() {
  const { isModalOpen } = useSelector((state: RootState) => state.searchModal);
  const { isSidebarOpen } = useSelector((state: RootState) => state.sidebar);
  const { data: sessions, isLoading, error } = useGetChatSessions();

  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    setIsLargeScreen(mediaQuery.matches);

    const handleResize = () => {
      setIsLargeScreen(mediaQuery.matches);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isLoading)
    return (
      <div className='flex justify-center items-center h-screen'>
        <ClipLoader
          color='#0F4988'
          loading={isLoading}
          // cssOverride={override}
          size={window.innerWidth < 640 ? 70 : 150}
          aria-label='Loading Spinner'
          data-testid='loader'
        />
      </div>
    );

  return (
    <div className='bg-black h-[calc(100vh-5rem)] text-white mt-20 overflow-hidden relative'>
      {isLargeScreen ? (
        <div className='flex flex-row'>
          {isSidebarOpen && <Sidebar chatSessions={sessions} />}
          {isModalOpen && <SearchModal chatSessions={sessions} />}
          <Chat />
        </div>
      ) : (
        <div className='relative w-full h-full'>
          <Chat />

          {isSidebarOpen && (
            <div className='absolute inset-0 z-50 flex'>
              <div
                className='absolute inset-0 bg-black bg-opacity-50'
              />

              <div className='relative z-10 w-full h-full '>
                <Sidebar chatSessions={sessions} />
              </div>
            </div>
          )}

          {isModalOpen && <SearchModal chatSessions={sessions} />}
        </div>
      )}
    </div>
  );
}
